<template>
  <CCol col="11" sm="5" lg="4" xl="4">
    <CCard>
      <CCardBody>
        <div v-if="widgetData === undefined">
          <h4 class="mb-2 w-50 d-block animated-background" style="height:20px;"></h4>

          <div class="mb-1">
            <span class="mt-3 mb-1 mb-lg-0 animated-background d-block w-75" style="height:20px;"></span>
            <span class="my-1 mb-lg-0 animated-background d-block w-100" style="height:20px;"></span>
          </div>

          <div class="animated-background d-block w-25" style="height:20px;"></div>
        </div>

        <div v-else>
          <h4 class="mb-2">{{ widgetData.title }}</h4>

          <div class="mb-1">
            <span class="mt-3 mb-1 mb-lg-0">
              <span class="font-lg font-weight-bold">{{ $commas(widgetData.items[0].val) }}</span>
              <span class="pfs-1" style="vertical-align: middle">{{ widgetData.items[0].name }}</span>
            </span>
            <span class="font-xl mx-2" style="vertical-align: middle">/</span>
            <span class="mb-1 mb-lg-0">
              <span class="font-lg font-weight-bold">{{ $commas(widgetData.items[1].val) }}</span>
              <span class="pfs-1" style="vertical-align: middle">{{ widgetData.items[1].name }}</span>
            </span>
          </div>

          <!-- <div :style="{ color: isNegativeChange ? 'red' : 'green' }" class="h6">
            <span>
              {{ Math.abs(percentChange) }}٪
              <FaIcon v-if="isNegativeChange" icon="arrow-up" style="
                  vertical-align: middle;
                  font-size: 9px;
                  transform: rotate(-135deg);
                " />
              <FaIcon v-else icon="arrow-up" style="
                  vertical-align: middle;
                  font-size: 9px;
                  transform: rotate(45deg);
                " />
            </span>
            <span class="pfs-2 text-black-50" style="font-size: 10px; vertical-align: middle">نسبت به ۳۰ روز گذشته</span>
          </div> -->
          <div class="h6">
            <span class="text-black-50" style="font-size: 10px; vertical-align: middle">
              <span class="font-weight-bold">۳۰ روز گذشته:</span> به طور میانگین {{ widgetData.items[2].val }} کلیک
            </span>
          </div>
        </div>
      </CCardBody>
    </CCard>
  </CCol>
</template>

<script>
import { widgetService } from "@/services/api";

export default {
  name: "ConversionsCard",

  data() {
    return {
      widgetData: undefined,
    };
  },

  computed: {
    // percentChange() {
    //   if (!this.widgetData.items[1].val) {
    //     let dif = this.widgetData.items[2].val - this.widgetData.items[1].val;

    //     return dif > 0 ? 100 : 0;
    //   }

    //   return parseFloat(100 * ( (this.widgetData.items[2].val - this.widgetData.items[1].val) / this.widgetData.items[1].val )).toFixed(2);
    // },
    // isNegativeChange() {
    //   return this.percentChange < 0;
    // },
  },

  created() {
    widgetService
      .fetch({
        needles: {
          12: { model: 12, config: {} },
        },
      })
      .then((res) => {
        this.widgetData = res.data.data[12].result;
      });
  },
};
</script>
